module.exports = __webpack_public_path__ + "assets/images/kayak-logo-bg.png";